export default "__VITE_ASSET__94bf3f65__"